module.exports = __webpack_public_path__ + "media/audio32.1e3e667f.mp3";